import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import OrganicParticles from './OrganicParticles';
// import WaitlistModal from './WaitlistModal';

const Hero = () => {
  const navigate = useNavigate();
  // const [isWaitlistModalOpen, setIsWaitlistModalOpen] = useState(false);
  
  // State for particles
  const [mousePosition, setMousePosition] = useState({ x: 0, y: 0 });
  const [scrollY, setScrollY] = useState(0);
  const [isReducedMotion, setIsReducedMotion] = useState(false);

  // Mouse tracking for particles
  useEffect(() => {
    const handleMouseMove = (e) => {
      setMousePosition({ x: e.clientX, y: e.clientY });
    };

    const handleScroll = () => {
      setScrollY(window.scrollY);
    };

    // Check for reduced motion preference
    const mediaQuery = window.matchMedia('(prefers-reduced-motion: reduce)');
    setIsReducedMotion(mediaQuery.matches);

    const handleReducedMotionChange = (e) => {
      setIsReducedMotion(e.matches);
    };

    mediaQuery.addEventListener('change', handleReducedMotionChange);
    window.addEventListener('mousemove', handleMouseMove);
    window.addEventListener('scroll', handleScroll);

    return () => {
      mediaQuery.removeEventListener('change', handleReducedMotionChange);
      window.removeEventListener('mousemove', handleMouseMove);
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);

  const handleLearnMoreClick = (e) => {
    e.preventDefault();
    navigate('/learn-more');
  };

  const handleUseItFreeClick = () => {
    window.open('https://www.humanaienterprise.com/auth', '_blank');
  };

  return (
    <div className="relative min-h-screen bg-black flex items-center overflow-hidden">
      {/* OrganicParticles Component */}
      <OrganicParticles 
        mousePosition={mousePosition} 
        scrollY={scrollY} 
        isReducedMotion={isReducedMotion} 
      />
      
      {/* Background gradient effect */}
      <div className="absolute inset-0 bg-gradient-to-br from-black via-black to-pink/20 opacity-80 z-0"></div>
      
      <div className="container mx-auto px-4 sm:px-6 z-20 py-20 sm:py-24 md:py-32">
        <div className="flex flex-col md:flex-row items-center justify-between">
          <div className="w-full md:w-6/12 mb-12 md:mb-0">
            <h1 className="text-3xl sm:text-4xl md:text-6xl lg:text-7xl font-bold text-white mb-6 leading-tight">
              <span className="block">AI Tools for</span>
              <span className="bg-gradient-to-r from-pink to-blue bg-clip-text text-transparent">
                Public Opinion Research
              </span>
            </h1>
            <p className="text-xl md:text-2xl text-gray-300 mb-8">
            Faster, smarter research: AI that builds, tests, and analyzes for you.
            </p>
            <div className="flex flex-col sm:flex-row space-y-4 sm:space-y-0 sm:space-x-4">
              <button 
                onClick={handleLearnMoreClick}
                className="px-8 py-3 bg-blue hover:bg-blue/90 text-white font-medium rounded-lg transition duration-300"
              >
                Learn More
              </button>
            </div>
          </div>
          
          <div className="w-full md:w-5/12 bg-black/40 backdrop-blur-sm border border-gray-800 p-8 rounded-xl">
            <h2 className="text-2xl font-bold text-white mb-6">Ready to Transform Your Research?</h2>
            
            <p className="text-gray-300 mb-6 leading-relaxed">
            Start using AI tools for surveys, message testing, and simulated respondents today.
            </p>
            
            <button
              onClick={handleUseItFreeClick}
              className="w-full py-4 bg-pink hover:bg-pink/90 text-white font-bold text-lg rounded-lg transition-all duration-300 hover:scale-105 flex items-center justify-center space-x-2"
            >
              <span className="text-lg">Use It Free</span>
              <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M13 7l5 5m0 0l-5 5m5-5H6" />
              </svg>
            </button>
            
            <div className="mt-4 text-center">
              <p className="text-sm text-gray-400">
                No credit card required • Start immediately
              </p>
            </div>
          </div>
        </div>
      </div>
      
      {/* Waitlist Modal */}
      {/* <WaitlistModal 
        isOpen={isWaitlistModalOpen} 
        onClose={() => setIsWaitlistModalOpen(false)} 
      /> */}
    </div>
  );
};

export default Hero; 